<template>
  <div>
    <h1>Lista de Modelos de Contrapartida</h1>
    <TableList />
  </div>
</template>

<script>
import TableList from "../Components/TableList.vue";

export default {
  components: { TableList },
};
</script>
